import { AvailabilityStatus } from '@models/global.model.ts';

export const serviceReservationStatusOptions = [
  { id: 'accepted', title: 'Accepted', value: 'accepted' },
  { id: 'canceled', title: 'Canceled', value: 'canceled' },
  // { id: 'rejected', title: 'Rejected', value: 'rejected' },
  { id: 'finished', title: 'Finished', value: 'finished' }
];

export const StatusMap: Partial<
  Record<AvailabilityStatus, { text: string; color: string }>
> = {
  [AvailabilityStatus.CheckedIn]: {
    text: 'Checked in',
    color: 'var(--pink)'
  },
  [AvailabilityStatus.Pending]: {
    text: 'Pending',
    color: 'var(--purple-3)'
  },
  [AvailabilityStatus.Confirmed]: {
    text: 'Finished',
    color: 'var(--yellow-2)'
  },
  [AvailabilityStatus.Canceled]: {
    text: 'Canceled',
    color: 'var(--red-5)'
  },
  [AvailabilityStatus.Archived]: {
    text: 'Archived',
    color: 'var(--gray-4'
  },
  [AvailabilityStatus.Reserved]: {
    text: 'Reservated',
    color: 'var(--blue-5)'
  },
  [AvailabilityStatus.Available]: {
    text: 'Check out today',
    color: 'var(--green-4)'
  },
  [AvailabilityStatus.Maintenance]: {
    text: 'Maintenance',
    color: 'var(--pink)'
  },
  [AvailabilityStatus.Rejected]: {
    text: 'Rejected',
    color: 'var(--red-2)'
  },
  [AvailabilityStatus.InProgress]: {
    text: 'In Progress',
    color: 'var(--purple-1)'
  },
  [AvailabilityStatus.Accepted]: {
    text: 'Accepted',
    color: 'var(--blue)'
  },
  [AvailabilityStatus.Ready]: {
    text: 'Ready',
    color: 'var(--green-3)'
  },
  [AvailabilityStatus.Finished]: {
    text: 'Finished',
    color: 'var(--green)'
  },
  [AvailabilityStatus.Demo]: {
    text: 'Demo',
    color: 'var(--blue)'
  },
  [AvailabilityStatus.InUse]: {
    text: 'In Use',
    color: 'var(--green-4)'
  }
};

export const isPublishedStatusOptions = [
  { title: 'Published', value: true },
  { title: 'Unpublished', value: false }
];

export const IsPublishedStatusMap: Record<
  'true' | 'false',
  { text: string; background: string; color: string }
> = {
  true: {
    text: 'published',
    background: 'var(--green-alpha-200)',
    color: 'var(--green)'
  },
  false: {
    text: 'unpublished',
    background: 'var(--red-alpha-200)',
    color: 'var(--red-2)'
  }
};
